"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    cardAsVariants: ()=>cardAsVariants,
    cardAs: ()=>cardAs,
    cardVariants: ()=>cardVariants
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const cardAsVariants = {
    div: {
        cardSlot: 'text-center'
    },
    button: {
        cardSlot: ''
    }
};
const cardAs = Object.keys(cardAsVariants);
const cardVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        cardContainerSlot: '',
        cardSlot: 'z-1 bg-primary-1 relative w-full p-3 transition-shadow hover:cursor-pointer active:shadow-sm',
        contentSlot: ''
    },
    variants: {
        as: cardAsVariants,
        size: {
            sm: {
                cardSlot: 'rounded-lg shadow-sm hover:shadow-lg'
            },
            md: {
                cardSlot: 'rounded-xl shadow-md hover:shadow-xl'
            }
        }
    },
    defaultVariants: {
        as: 'button',
        size: 'md',
        topSubPanelEmphasis: 'none',
        bottomSubPanelEmphasis: 'none'
    }
});
exports.cardAs = __webpack_exports__.cardAs;
exports.cardAsVariants = __webpack_exports__.cardAsVariants;
exports.cardVariants = __webpack_exports__.cardVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "cardAs",
    "cardAsVariants",
    "cardVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
